import React from 'react'
import {useTranslation} from 'react-i18next'
import {useInjection} from 'dna-react-ioc'
import {PayByLinkSendMessageStoreSymbol} from '@/pages/PayByLink'
import {ModalFormFooter} from '@/components'
import {SendMessageStore} from '@/stores'
import {LinkShareFooterProps} from './props'

export const LinkShareFooter: React.FC<LinkShareFooterProps> = ({
    type,
    formId,
    form,
    closeModal
}) => {
    const {t} = useTranslation()
    const store = useInjection<SendMessageStore>(PayByLinkSendMessageStoreSymbol)
    const {isLoading, closeLinkDetailsModal} = store
    const okText = t('LinkShareFooter.send', {context: type})

    const onCancel = () => {
        form.resetFields()
        closeLinkDetailsModal()
        closeModal()
    }

    return (
        <ModalFormFooter
            formId={formId}
            okText={okText}
            confirmLoading={isLoading}
            onCancel={onCancel}
        />
    )
}
